// Add special mobile navigation

var isMobil = false;

function mobileNavigation() {

  // $('.dl-trigger').on('click', function(){
  //   $('.dl-menu').slideToggle();
  // });
  //
  // $('li.submenu.sibling').on('click', function(event){
  //   event.preventDefault();
  //   $(this).children('.dl-submenu.level_2').toggle();
  // });

    if(viewport().width > 990 && isMobil === true) {
        $('#dl-menu *').unbind('.dlmenu');
        $(".dl-back").remove();
        isMobil = false;
    } else if(viewport().width <= 990 && isMobil === false) {
        $('#dl-menu').dlmenu( {backLabel:(typeof maw == "undefined") ? 'Zurück' : maw.zurueck});
        isMobil = true;
    }

}
